// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"7e8b83d7","558":"f407bc4c","654":"26983d7b","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};